import {
	ChangeDetectionStrategy,
	Component,
	Input,
	OnDestroy,
	OnInit
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SNModalService } from '@web-services/modal/snModal.service';
import { SNModal } from '@web-services/modal/snModal.interfaces';
import { Subject } from 'rxjs';
import {
	ReportInputItem,
	ReportOverviewItem
} from '@models/admin/reports.model';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ReportsOverviewDataProvider } from '@services/admin/reports/reports-overview.data.service';
import { MessageService } from '@services/helpers/message-service/message.service';
import { GeneralAction } from '@models/models';

@Component({
	selector: 'generate-modal',
	template: require('./generate-report.modal.html'),
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenerateReportModalComponent
	implements OnInit, OnDestroy, SNModal {
	@Input() reportOverviewItem: ReportOverviewItem;
	@Input() action: GeneralAction;

	reportsInputFields: Array<ReportInputItem> = [];
	inputItem: ReportInputItem;

	generateReportForm: FormGroup;
	unsubscribe: Subject<void> = new Subject<void>();
	btnDisable: boolean;

	constructor(
		private reportsOverviewService: ReportsOverviewDataProvider,
		private messageService: MessageService,
		public activeModal: NgbActiveModal,
		private modalService: SNModalService,
		private fb: FormBuilder
	) {}

	onSubmit() {}

	ngOnInit(): void {
		this.generateReportForm = this.fb.group({});

		for (const reportParam of this.reportOverviewItem.reportParams) {
			this.inputItem = {
				displayName: reportParam.displayName,
				description: reportParam.description,
				formControlName: reportParam.name,
				type: reportParam.widgetType,
				placeholder: '',
				validators: []
			};

			this.reportsInputFields.push(this.inputItem);

			const control = this.fb.control('', null);
			this.generateReportForm.addControl(reportParam.name, control);
		}
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	onDismiss(): void {
		this.activeModal.close();
	}

	saveCompanyInfo(): void {
		if (this.generateReportForm.valid) {
			this.modalService.setModalData(this.generateReportForm.value);
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/admin/report/generate-modal/generate-report.modal.ts